import { render } from "./servicios.vue?vue&type=template&id=4099c1da&scoped=true"
import script from "./servicios.vue?vue&type=script&lang=js"
export * from "./servicios.vue?vue&type=script&lang=js"

import "./servicios.vue?vue&type=style&index=0&id=4099c1da&scoped=true&lang=css"

import exportComponent from "C:\\Users\\yordis.escorcia\\Downloads\\relojito\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4099c1da"]])

export default __exports__